import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { get, size, split, forEach, includes } from 'lodash';
import { Avatar } from 'antd';
import { Loading, FlexContainer } from '../../common';
import { currentUserInfo } from '../../../utils/misc';
import { autoLogout } from '../../../utils/awsAuth';
// TODO: migrate styles
let tokenInterval;

const AccountContainer = styled.div`
    min-width: 25px;
    min-height: 25px;
    border-radius: 50%;
    background-color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const styles = {
    container: {
        marginLeft: 10,
        display: 'flex',
        alignItems: 'center'
    },
    userNameContainer: {
        margin: '0 10px'
    }
};

const AccountAvatar = () => {
    const [userName, setUserName] = useState(null);
    const initials = () => {
        let result = '';
        forEach(split(userName, ' '), item => {
            result = result + item.charAt(0);
        });
        return result;
    };

    useEffect(() => {
        clearInterval(tokenInterval);
        if (includes([
            '/room-management',
            '/orders',
            '/dashboard-ja',
            '/audit-monitor',
            '/orders-monitor'
        ],  window.location.pathname)) {
            console.log(`Token will be updated automatically in this page (${window.location.pathname}). The session will be whole day active.`)
            tokenInterval = setInterval(() => {
                autoLogout()
            }, 1000);
        }
    }, [window.location.pathname])

    useEffect(() => {
        async function fetchCurrentUserInfo () {
            const name = get(await currentUserInfo(), 'name', 'Usuario');
            setUserName(name);
        }

        fetchCurrentUserInfo();
    }, []);

    return (
        <Loading loading={!size(userName)}>
            <FlexContainer align='center'>
                <div style={styles.userNameContainer}>
                    <span style={{ fontSize: '11px' }}>{userName}</span>
                </div>
                {/* <AccountContainer>
                    <Icon name='account' size={18} color='#ffffff' />
                </AccountContainer> */}
                <Avatar size='large'>{ initials() }</Avatar>
            </FlexContainer>
        </Loading>
    );
};

export default AccountAvatar;
